import React, { useEffect, useState } from 'react';
import { FlatList, View, ScrollView, ActivityIndicator } from "react-native"
import { connect } from "react-redux"
import Colors from '../../constants/Colorsv2';
import Styles from '../../constants/Styles';
import { social_getPlayerFollowers } from "../../store/actionsv1/social"
import { PlayerFollowerProps } from '../../store/types/soc_svc';
import PlayerCard from './components/PlayerCard';


const PlayerFollowers = ({ route, navigation, player, social_getPlayerFollowers, player_followers }) => {
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        getPlayerFollowersFromServer(route.params.player_id, route.params.status)
    },[])

    const getPlayerFollowersFromServer = async(player_id:string, status:string) => {
        setLoading(true)
        await social_getPlayerFollowers(player_id, status)
        setLoading(false)
    }

    const renderPlayerFollowers = (data: { item: PlayerFollowerProps, index:number }) => {
        if(!data.item.playerDetails){ return <></> }
        return (
            <View style={{ margin:5 }}>
                <PlayerCard player={data.item.playerDetails} viewer_id={player.player_id} onPlayerPress={(player) => navigation.push('SocialProfile', { player_id:player.player_id })}/>

            </View>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <ScrollView style={{ flex:1 }}>
                {loading ?
                <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                </View>
                :
                <FlatList data={player_followers} renderItem={renderPlayerFollowers} keyExtractor={(item) => item.player_follower_id.toString()}/>
                }
            </ScrollView>
        </View>
    )
}


const mapStateToProps = (state: any) => {
    return {
        player: state.player.player,
        player_followers: state.social.viewing_player_followers
    }
}   

const mapDispatchToProps = (dispatch:any) => {
    return {
        social_getPlayerFollowers: (player_id:string, status:string, offset:number) => dispatch(social_getPlayerFollowers(player_id, status, offset))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayerFollowers)